import { useState } from "react";
import InteractiveCarousel from "../../../../../../components/InteractiveCarousel";
import "./index.css";
import { formatEPRAnswers } from "./formatEPRAnswers";
import {
  submitEPRAnswers,
  updateEPRAnswers,
} from "../../../../../../apis/Business/EPRAnswers";
import { getEPRDefaultValue } from "./getDefaultValue";

const EPRCarousel = ({
  businessId,
  setIsQASubmitted,
  chosenYear,
  period,
  allocated_year,
  existingData = null,
  setExistingData,
}) => {
  const questionItems = [
    {
      id: 1,
      title: "Energy",
      questions: [
        {
          content: "Do you have symbiotic input of energy?",
          type: "switch",
          options: ["Yes", "No"],
          answer: null,
        },
        {
          content: "Do you purchase 100% of the production?",
          type: "switch",
          options: ["Yes", "No"],
          answer: null,
        },
      ],
    },
    {
      id: 2,
      title: "Vehicles",
      questions: [
        {
          content: "Do you have leased vehicles using fuel?",
          type: "switch",
          options: ["Yes", "No"],
          answer: null,
        },
        {
          content: "Estimated fuels to leased vehicles?",
          type: "input",
          inputType: "number",
          unit: "%",
          answer: null,
        },
      ],
    },
    {
      id: 3,
      title: "Leased Vehicles",
      questions: [
        {
          content:
            "Is any proportion of the fuel/biofuel complying to the criterias for biofuel according to GHG",
          type: "switchWithInput",
          answer: null,
        },
        {
          content: "Is any proportion of the fuel biomass",
          type: "switch",
          options: ["Yes", "No"],
          answer: null,
        },
      ],
    },
    {
      id: 4,
      title: "Engine without a license plate",
      questions: [
        {
          content: "Do you have leased engines using fuel?",
          type: "switch",
          options: ["Yes", "No"],
          answer: null,
        },
        {
          content: "Estimated fuel to leased engines",
          type: "input",
          inputType: "number",
          unit: "%",
          answer: null,
        },
      ],
    },
    {
      id: 5,
      title: "Leased engines without a license plate",
      questions: [
        {
          content:
            "Is any proportion of the fuel/biofuel complying to the criterias for biofuel according to the GHG",
          type: "switchWithInput",
          answer: null,
        },
      ],
    },
    {
      id: 6,
      title: "Emissions from gasses",
      questions: [
        {
          content:
            "What proportions of your refrigeration/aircon inputs are leased? (eg. heatpumpps, refrigerators)",
          type: "switchWithInput",
          answer: null,
        },
      ],
    },
    {
      id: 7,
      title: "Emissions from gasses",
      questions: [
        {
          content:
            "What proportions of your fire suppressant inputs are leased?",
          type: "input",
          inputType: "number",
          unit: "%",
          answer: null,
        },
      ],
    },
    {
      id: 8,
      title: "Transport & Distribution",
      questions: [
        {
          content:
            "How much of your transport needs for incoming deliveries are catered to by:",
          type: "multiInput",
          inputs: [
            { label: "Car", type: "number", unit: "%", answer: null },
            { label: "Van", type: "number", unit: "%", answer: null },
            { label: "Truck", type: "number", unit: "%", answer: null },
            { label: "Train", type: "number", unit: "%", answer: null },
            { label: "Plane", type: "number", unit: "%", answer: null },
            { label: "Ship", type: "number", unit: "%", answer: null },
          ],
        },
      ],
    },
    {
      id: 9,
      title: "Transport & Distribution",
      questions: [
        {
          content:
            "How much of your transport needs for outgoing deliveries are catered to by:",
          type: "multiInput",
          inputs: [
            { label: "Car", type: "number", unit: "%", answer: null },
            { label: "Van", type: "number", unit: "%", answer: null },
            { label: "Truck", type: "number", unit: "%", answer: null },
            { label: "Train", type: "number", unit: "%", answer: null },
            { label: "Plane", type: "number", unit: "%", answer: null },
            { label: "Ship", type: "number", unit: "%", answer: null },
          ],
        },
      ],
    },
    {
      id: 10,
      title: "Business travels",
      questions: [
        {
          content: "Do you normally travel by (estimate)?",
          type: "multiInput",
          inputs: [
            { label: "Car", type: "number", unit: "%", answer: null },
            { label: "Van", type: "number", unit: "%", answer: null },
            { label: "Truck", type: "number", unit: "%", answer: null },
            { label: "Train", type: "number", unit: "%", answer: null },
            { label: "Plane", type: "number", unit: "%", answer: null },
            { label: "Ship", type: "number", unit: "%", answer: null },
          ],
        },
      ],
    },
    {
      id: 11,
      title: "Surplus materials",
      questions: [
        {
          content: "What fractions do you usually send out the door?",
          type: "multiInput",
          inputs: [
            { label: "Landfill", type: "number", unit: "%", answer: null },
            { label: "Recycling", type: "number", unit: "%", answer: null },
            { label: "Incineration", type: "number", unit: "%", answer: null },
            { label: "Compost", type: "number", unit: "%", answer: null },
          ],
        },
      ],
    },
  ];

  const [answers, setAnswers] = useState(() => {
    // If existing data is provided, pre-fill the initial answers
    if (existingData) {
      const initialAnswers = {};

      // Iterate through question items and pre-fill answers
      questionItems.forEach((item) => {
        initialAnswers[item.id] = item.questions.reduce(
          (acc, question, index) => {
            // Use the formatEPRAnswers helper to get default values
            const defaultValue = getEPRDefaultValue(
              item.id,
              index,
              existingData
            );

            acc[index] = {
              value: defaultValue,
              inputValue: defaultValue,
            };

            return acc;
          },
          {}
        );
      });

      return initialAnswers;
    }

    return {};
  });
  const [loading, setLoading] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    const formattedAnswers = formatEPRAnswers(
      answers,
      businessId,
      existingData
    );

    existingData && Object.keys(existingData).length > 0
      ? updateEPRAnswers({
          businessId,
          year:
            existingData && Object.keys(existingData).length > 0
              ? existingData.year
              : chosenYear,
          period:
            existingData && Object.keys(existingData).length > 0
              ? existingData.period
              : period,
          allocated_year:
            existingData && Object.keys(existingData).length > 0
              ? existingData.allocated_year
              : allocated_year,
          answers: formattedAnswers,
          loading,
          setLoading,
          setObjects: setExistingData,
          useToast: true,
          callback: (data) => {
            setIsQASubmitted(true);
          },
          setErrorMessage,
        })
      : submitEPRAnswers({
          businessId,
          year: chosenYear,
          period: period,
          allocated_year: allocated_year,
          answers: formattedAnswers,
          loading,
          setLoading,
          useToast: true,
          callback: (data) => {
            setIsQASubmitted(true);
          },
          setErrorMessage,
        });
    setIsQASubmitted(true);
  };
  return (
    <>
      <InteractiveCarousel
        items={questionItems}
        classNameCard={"card-interactive-carousel-active"}
        typographyColor={"white"}
        isTitle={true}
        titleColor={"#0C376A"}
        answers={answers}
        setAnswers={setAnswers}
        onSubmit={handleSubmit}
        loading={loading}
      />
    </>
  );
};

export default EPRCarousel;
